import * as angular from 'angular';
import { BusinessDisplayBridge } from './BusinessDisplayBridge';

angular
  .module('flowingly.runner.directives')
  .component('businessDisplay', BusinessDisplayBridge);
